const languageSwitcher = document.querySelector("header#masthead .language_switcher");
const languageSwitcherButton = document.querySelector("header#masthead .language_switcher .language_button");
const languageSwitcherMenu = document.querySelector("header#masthead .language_switcher .language-menu");
const hamburgerButton = document.querySelector(".primary_mobile_menu_button");
const closeMobileMenu = document.querySelector(".close_mobile_menu");
const siteMainNavigation = document.querySelector(".site-main-navigation");
const megaMenuItem = document.querySelectorAll("#mega-menu-primary .mega-menu-item.mega-menu-item-has-children > a");
if (languageSwitcherButton) {
    languageSwitcherButton.addEventListener("click", function () {
        if (languageSwitcher) {
            if (languageSwitcher.classList.contains("active")) {
                languageSwitcher.classList.remove("active");
                languageSwitcherButton.setAttribute("aria-expanded", 'false');
                languageSwitcherButton.setAttribute("aria-label", 'Open Language Switcher');
            } else {
                languageSwitcher.classList.add("active");
                languageSwitcherButton.setAttribute("aria-expanded", 'true');
                languageSwitcherButton.setAttribute("aria-label", 'Close Language Switcher');
            }
        }
    })
}

// if (megaMenuItem) {
//     megaMenuItem.forEach(element => {
//         element.addEventListener("click", function() {
//             if (window.outerWidth < 992) {
//                 element.parentElement.classList.add("activeMenu");
//                 if (siteMainNavigation) {
//                     setTimeout(() => {
//                         siteMainNavigation.classList.add("childActive");
//                     }, 700);
//                 }
//             } else {
//                 megaMenuItem.forEach(element => {
//                     element.parentElement.classList.remove("activeMenu");
//                 });
//                 if (siteMainNavigation) {
//                     siteMainNavigation.classList.remove("childActive");
//                 }
//             }
//         })
//     });
// }

document.addEventListener("click", function (e) {
    if (e.target.closest(".language-menu") == null && !e.target.classList.contains("language_button")) {
        if (languageSwitcher) {
            languageSwitcher.classList.remove("active");
            if (languageSwitcherButton) {
                languageSwitcherButton.setAttribute("aria-expanded", 'false');
                languageSwitcherButton.setAttribute("aria-label", 'Open Language Switcher');
            }
        }
    }
    if (e.target.classList.contains("primary_mobile_menu_button")) {
        document.body.classList.add("body_mobile_menu_open");
    }
    if (e.target.classList.contains("close_mobile_menu")) {
        document.body.classList.remove("body_mobile_menu_open");
        setTimeout(() => {
            if (siteMainNavigation) {
                siteMainNavigation.classList.add("childPriority");
                siteMainNavigation.classList.remove("childActive");
            }
            setTimeout(() => {
                if (megaMenuItem) {
                    megaMenuItem.forEach(element => {
                        element.parentElement.classList.remove("activeMenu");
                    });
                }
                setTimeout(() => {
                    if (siteMainNavigation) {
                        siteMainNavigation.classList.remove("childPriority");
                    }
                }, 500);
            }, 800);
        }, 500);
    }
    if (e.target.classList.contains("mega-menu-link") && e.target.parentElement.classList.contains("mega-menu-item-has-children")) {
        if (window.outerWidth < 992) {
            e.target.parentElement.classList.add("activeMenu");
            if (siteMainNavigation) {
                setTimeout(() => {
                    siteMainNavigation.classList.add("childActive");
                }, 700);
            }
        } else {
            if (siteMainNavigation) {
                siteMainNavigation.classList.add("childPriority");
                siteMainNavigation.classList.remove("childActive");
            }
            setTimeout(() => {
                if (siteMainNavigation) {
                    siteMainNavigation.classList.remove("childPriority");
                }
                if (megaMenuItem) {
                    megaMenuItem.forEach(element => {
                        e.target.parentElement.classList.remove("activeMenu");
                    });
                }
            }, 800);
        }
    }
    if (e.target.classList.contains("back_to_main_menu")) {
        if (siteMainNavigation) {
            siteMainNavigation.classList.add("childPriority");
            siteMainNavigation.classList.remove("childActive");
        }
        setTimeout(() => {
            if (megaMenuItem) {
                megaMenuItem.forEach(element => {
                    element.parentElement.classList.remove("activeMenu");
                });
            }
            setTimeout(() => {
                if (siteMainNavigation) {
                    siteMainNavigation.classList.remove("childPriority");
                }
            }, 500);
        }, 800);
    }
})